import { useEffect, useState } from 'react';
import { useRxCollection } from 'rxdb-hooks';

import { sentryCaptureException } from '../../utilities/sentryCaptureException';
import { getValueFromLocalStorage } from '../../utilities/utilityFunctions';
import { RxdbCollectionName } from '../rxdbCollectionName';
import type {
  LineandSectionPropertiesListCollection,
  LineandSectionPropertiesListDocument,
} from './lineandSectionPropertiesDetails.types';

export const useLineAndSectionProperties = () => {
  const lineandSectionPropertiesListCollection: LineandSectionPropertiesListCollection =
    useRxCollection(RxdbCollectionName.LINE_AND_SECTION_PROPERTIES_LIST);

  const [lineandSectionPropertiesListInitialized, setLineandSectionPropertiesListInitialized] =
    useState<boolean>(false);

  useEffect(() => {
    if (lineandSectionPropertiesListCollection) setLineandSectionPropertiesListInitialized(true);
  }, [lineandSectionPropertiesListCollection]);

  const getLineandSectionPropertiesList = async (): Promise<
    LineandSectionPropertiesListDocument[]
  > => {
    if (!lineandSectionPropertiesListCollection) return [];
    let lineandSectionPropertiesList: LineandSectionPropertiesListDocument[];
    try {
      lineandSectionPropertiesList = await lineandSectionPropertiesListCollection
        ?.find({
          selector: {
            assetId: getValueFromLocalStorage('assetId'),
          },
        })
        .exec();
      return lineandSectionPropertiesList;
    } catch (error) {
      sentryCaptureException(
        error,
        '🚀 ~ file: useLineAndSectionProperties.ts ~ line 38 ~ getLineandSectionPropertiesList ~ error',
      );
    }
    return [];
  };

  return {
    lineandSectionPropertiesListInitialized,
    getLineandSectionPropertiesList,
    lineandSectionPropertiesListCollection,
  };
};
